// import produce from 'immer';
// @ts-nocheck
import { useEffect, useState } from 'react';
import { RJSFSchema } from '@rjsf/utils';
import userGroupForm from '../components/ClientGroups/userGroupForm.json';
import useClientGroupUsers from './useClientGroupUsers';

const useClientGroupAddUserForm = (currentClientId, isAddForm) => {
  const { groupUsers, isLoading: isUsersLoading } =
    useClientGroupUsers(currentClientId);

  const [updated, setUpdated] = useState(false);
  const [userGroupFormSchema, setSchema] = useState<RJSFSchema>(
    userGroupForm as RJSFSchema
  );

  useEffect(() => {
    if (groupUsers) {
      const allowedUsers = Object.values(groupUsers).filter((user) => {
        return (
          parseInt(user.ClientId) !== parseInt(currentClientId) &&
          (isAddForm ? !user.IsAdded : user.IsAdded)
        );
      });

      const oneOf = [
        ...allowedUsers.map((client: any) => ({
          const: client.id,
          title: client.UserName,
        })),
      ];

      setSchema((schema) => {
        schema = Object.assign({}, schema, {
          title: isAddForm
            ? 'Add Existing User to group'
            : 'Remove Existing User from group',
          properties: Object.assign({}, schema.properties, {
            UserId: Object.assign({}, schema.properties.UserId, {
              oneOf: oneOf,
            }),
          }),
        });

        return schema;
      });
      setUpdated(true);
    }
  }, [groupUsers, currentClientId, isAddForm]);

  return {
    userGroupFormSchema,
    isLoading: isUsersLoading,
    updated,
  };
};
export default useClientGroupAddUserForm;
